import { withErrorBoundary } from '@sentry/react'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { AppModelDataProvider } from '@/pages/dashboard/AppModelDataProvider'
import { DashboardPage } from '@/pages/dashboard/DashboardPage'
import { SentryErrorPage } from '@/pages/error/SentryErrorPage'

const DashboardDataProvider = () => (
  <AppModelDataProvider>
    <DashboardPage />
  </AppModelDataProvider>
)

const dashboardSearchZod = z.object({
  central_id: z.number().optional(),
  transportRequestId: z.string().optional(),
})

export const Route = createFileRoute('/')({
  component: withErrorBoundary(DashboardDataProvider, {
    fallback: SentryErrorPage,
    beforeCapture: (scope) => scope.setTag('route', Route.fullPath),
  }),
  validateSearch: dashboardSearchZod,
})
